/**
 * @generated SignedSource<<e3410ef407607d41a06dfb2767396690>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatThreadItemFragment$data = {
  readonly chat: {
    readonly greeting: {
      readonly id: string;
      readonly received: boolean;
    };
    readonly lastMessage: {
      readonly content: string | null;
      readonly createdOn: string | null;
      readonly id: string;
    };
    readonly readState: {
      readonly hasUnread: boolean;
      readonly id: string;
      readonly unreadCount: number;
    } | null;
  } | null;
  readonly " $fragmentType": "ChatThreadItemFragment";
};
export type ChatThreadItemFragment$key = {
  readonly " $data"?: ChatThreadItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatThreadItemFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatThreadItemFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AppointmentChatType",
      "kind": "LinkedField",
      "name": "chat",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ChatReadStateType",
          "kind": "LinkedField",
          "name": "readState",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "unreadCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasUnread",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AppointmentChatLastMessage",
          "kind": "LinkedField",
          "name": "lastMessage",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "content",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdOn",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AppointmentChatGreeting",
          "kind": "LinkedField",
          "name": "greeting",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "received",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Appointment",
  "abstractKey": null
};
})();

(node as any).hash = "d3b7c0d89fb466e125a69db0671a6132";

export default node;
